/* src/app/modules/print-cards/components/cards/inflators/print-card-content-inflator/card-content-inflator.component.scss */
.print-card-content-inflator-container {
  display: grid;
  position: absolute;
  overflow: hidden;
  box-sizing: border-box;
}
/*# sourceMappingURL=card-content-inflator.component.css.map */
